var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      attrs: { id: "lateral-menu-opener" },
      on: { click: _vm.lateralMenu_open },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        attrs: { id: "lateral-menu-closure" },
        on: { click: _vm.lateralMenu_close },
      },
      [_vm._v("✕")]
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "lateral-menu" } }, [
      _c(
        "ul",
        [
          _c("router-link", {
            attrs: { to: "/admin/reservations" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c("li", { class: [isExactActive && "active"] }, [
                      _c("a", { attrs: { href: href } }, [
                        _vm._v("Réservations"),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("router-link", {
            attrs: { to: "/admin/bons-cadeaux" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c("li", { class: [isExactActive && "active"] }, [
                      _c("a", { attrs: { href: href } }, [
                        _vm._v("Bons cadeaux"),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("router-link", {
            attrs: { to: "/admin/codes-promos" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c("li", { class: [isExactActive && "active"] }, [
                      _c("a", { attrs: { href: href } }, [
                        _vm._v("Codes promos"),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("router-link", {
            attrs: { to: "/admin/sessions/nestor" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c("li", { class: [isExactActive && "active"] }, [
                      _c("a", { attrs: { href: href } }, [_vm._v("Sessions")]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("router-link", {
            attrs: { to: "/" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c(
                      "li",
                      {
                        staticClass: "headerMenu_reserver",
                        class: [isExactActive && "active"],
                      },
                      [
                        _c("a", { attrs: { href: href } }, [
                          _vm._v("Lock Quest"),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }